import React from "react";
import PropTypes from "prop-types";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";

import styles from "./webstories.m.css";
import { VikatanAsidebar } from "../rows/ad-free";

export class ShortsPage extends React.Component {
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
    const embedFeed = document.createElement("script");
    embedFeed.src = "//asset.fwcdn2.com/js/embed-feed.js";
    embedFeed.async = true;

    const storyblock = document.createElement("script");
    storyblock.src = "//asset.fwcdn2.com/js/storyblock.js";
    storyblock.async = true;

    document.body.appendChild(embedFeed);
    document.body.appendChild(storyblock);
  }

  render() {
    return (
      <React.Fragment>
        <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
          <div />
          <div className="page-content infinity-page">
            <div className={`container ${styles["story-grid"]}`}>
              <div className={styles["main-content"]}>
                <h2 className={styles["title"]}>விகடன் ஷார்ட்ஸ்</h2>
                <fw-embed-feed
                  channel="vikatan"
                  playlist="g1WWp5"
                  mode="grid"
                  open_in="default"
                  max_videos="0"
                  placement="middle"
                  player_placement="bottom-right"
                />
              </div>
              <aside className={styles.sidebar}>
                <VikatanAsidebar />
              </aside>
            </div>
          </div>

          <div />
        </div>
      </React.Fragment>
    );
  }
}

ShortsPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
